module.exports = __webpack_public_path__ + "img/1511309253.d5786ffe.jpg";